<template>
    <v-card-text>
        <v-form v-model="valid">

                <v-text-field
                    v-model="username"
                    :rules="validateUsername"
                    :label="$t('username')"
                    prepend-icon="mdi-account"
                    required
                ></v-text-field>

                <v-text-field
                    v-model="password"
                    :rules="validatePassword"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    :label="$t('password')"
                    prepend-icon="mdi-lock"
                    required
                ></v-text-field>

                <v-btn
                    :disabled="!valid"
                    color="primary"
                    @click="login"
                    >
                    {{ $t('signin') }}
                </v-btn>

        </v-form>
  </v-card-text>
</template>

<script>

  import validate from '@/model/utils/Validate.js'
  import config from '@/../config.js'
  import axios from 'axios';
  import Staff from '@/model/instance/Staff.js'

  export default {
    data: () => ({
      showPassword: false,
      valid: true,
      username: '',
      password: '',
      validateUsername : validate.validateUsername,
      validatePassword : validate.validatePassword
    }),
    methods: {
      login () {
          const { username,password } = this;
          axios
          .post(config.api.url.public.login,{username : username,password:password})
          .then(response => {
            let data = response.data;
            if(data.isSuccess){
              
              Staff.setUsername(username);
              Staff.setToken(data.token);
              Staff.setLang(data.lang);
              Staff.setMenuList(data.menu_list);
              Staff.setDisplayname(data.displayname);
              this.$router.replace({name:this.$store.state.to_name}) 
            }
          })
          .catch(error => {
            this.$router.push({name:'Error',params:error}) 
          })
      },
    },
  }
</script>